import { defineComponent as _defineComponent } from 'vue'
import AccountLimitsAndRequirementsHelpPage from '../../alt21Links/AccountLimitsAndRequirementsHelpPage.vue';
import SliderInput from 'ah-common-lib/src/common/components/SliderInput.vue';
import { VCol } from 'ah-common-lib/src/common/components';
import { VRow } from 'ah-common-lib/src/common/components';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariationMarginEditor',
  props: {
  variationMarginPercentage: {
    type: Number,
    required: true,
  },
},
  emits: {
  'update:variationMarginPercentage': (_payload: number) => true,
},
  setup(__props, { emit }) {

const props = __props;

const STEP_MULTIPLIER = 0.5;

const DEFAULT_PERCENTAGES = {
  min: 1,
  max: 10,
};





/**
 * Since the percentage value from BE comes (an also receives it) in decimal, i.e. a value between 0 and 1
 * We need to convert this to real percentage, i.e. a value between 0 and 100%
 */
const parsedVariationMarginPercentage = computed(() => props.variationMarginPercentage * 100);

const selectedVariationMarginValue = ref<number>(parsedVariationMarginPercentage.value);

watch(selectedVariationMarginValue, (newAmount) => {
  /**
   * Since the percentage value from BE comes (an also receives it) in decimal, i.e. a value between 0 and 1
   * And inside of this component we convert it to real percentage, i.e. a value between 0 and 100%
   * When we emit the value we need to convert it again to decimal
   */
  const percentageToDecimal = newAmount / 100;
  emit('update:variationMarginPercentage', percentageToDecimal);
});

return { __sfc: true,STEP_MULTIPLIER, DEFAULT_PERCENTAGES, props, emit, parsedVariationMarginPercentage, selectedVariationMarginValue, AccountLimitsAndRequirementsHelpPage, SliderInput, VCol, VRow }
}

})